import { render, staticRenderFns } from "./profileMenu.vue?vue&type=template&id=b8ee1e98&scoped=true"
import script from "./profileMenu.vue?vue&type=script&lang=js"
export * from "./profileMenu.vue?vue&type=script&lang=js"
import style0 from "./profileMenu.vue?vue&type=style&index=0&id=b8ee1e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ee1e98",
  null
  
)

export default component.exports